/**
 * Primary Fit Guide — fitguide-widget.js
 * UI layer. Requires fitguide-tables.js + fitguide.js loaded first.
 *
 * Mount: any element with [data-fit-guide-mount]
 *   data-fit-value           — product custom.fit_value (0–100, default 50)
 *   data-fit-us-support-bra — "true" if Mesh Support Bra
 *   data-fit-equiv-product  — URL of paired Understatement product (or "")
 *   data-context            — "pdp" (trigger → modal) | "" (inline, e.g. /pages/fit-guide)
 */

/* eslint-disable */
(function (root) {
  'use strict';

  // ── Brand display config ──────────────────────────────────────
  // keys: multiple keys combined into one row with " / " separator; row hidden if all null
  var BRAND_ROWS = [
    { label: 'Else',            keys: ['elseBra', 'elseLetter'], url: '/collections/else' },
    { label: 'Nette Rose',      keys: ['nrBra', 'nrBralette'],  url: '/collections/nette-rose' },
    { label: 'Understatement',  keys: ['usStandard', 'usSupport'], url: '/collections/understatement' },
    { label: 'Love & Swans',    keys: ['lsSoft'],               url: '/collections/love-and-swans' },
    { label: 'Maison Close',    keys: ['maisonClose'],          url: '/collections/maison-close' },
    { label: 'TA-CT',           keys: ['tact'],                 url: '/collections/ta-ct' },
  ];

  // ── Brand → result-key mapping (strict lookup, no cross-brand fallthrough) ──
  // vendors: lowercased product.vendor values that map to this brand's size keys
  // For unknown vendors _findBrandSize returns null; caller falls back to result.primary.
  var BRAND_LOOKUP = [
    { vendors: ['primary', 'else', 'else lingerie'],      keys: ['elseBra', 'elseLetter'] },
    { vendors: ['understatement'],                        keys: ['usStandard', 'usSupport'] },
    { vendors: ['nette rose'],                            keys: ['nrBra', 'nrBralette'] },
    { vendors: ['love & swans', 'love and swans'],        keys: ['lsSoft'] },
    { vendors: ['maison close'],                          keys: ['maisonClose'] },
    { vendors: ['ta-ct', 'tact'],                         keys: ['tact'] },
  ];

  // ── Helpers ───────────────────────────────────────────────────
  function tpl(str) { return str.replace(/\s{2,}/g, ' ').trim(); }

  function buildPips(score) {
    var html = '<span class="fg__pips" aria-label="Confidence ' + score + ' of 5">';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="fg__pip' + (i <= score ? ' fg__pip--on' : '') + '"></span>';
    }
    return html + '</span>';
  }

  // ── Form templates ────────────────────────────────────────────
  // Uses pill buttons + hidden inputs. Pill clicks handled in _bindPills().
  var FORM_TEMPLATES = {
    A: tpl(`
      <form data-fg-form data-method="A" class="fg__form">
        <p class="fg__instruction">Use the size of the most recent bra you purchased</p>
        <div class="fg__field">
          <label class="fg__field-label">Band</label>
          <input type="hidden" name="band" value="">
          <div class="fg__pill-row" data-fg-pill-group="band">
            <button type="button" class="fg__pill" data-value="6">6</button>
            <button type="button" class="fg__pill" data-value="8">8</button>
            <button type="button" class="fg__pill" data-value="10">10</button>
            <button type="button" class="fg__pill" data-value="12">12</button>
            <button type="button" class="fg__pill" data-value="14">14</button>
            <button type="button" class="fg__pill" data-value="16">16</button>
          </div>
        </div>
        <div class="fg__field">
          <label class="fg__field-label">Cup</label>
          <input type="hidden" name="cup" value="">
          <div class="fg__pill-row" data-fg-pill-group="cup">
            <button type="button" class="fg__pill" data-value="AA">AA</button>
            <button type="button" class="fg__pill" data-value="A">A</button>
            <button type="button" class="fg__pill" data-value="B">B</button>
            <button type="button" class="fg__pill" data-value="C">C</button>
            <button type="button" class="fg__pill" data-value="D">D</button>
            <button type="button" class="fg__pill" data-value="DD">DD</button>
            <button type="button" class="fg__pill" data-value="E">E</button>
            <button type="button" class="fg__pill" data-value="F">F</button>
            <button type="button" class="fg__pill" data-value="G">G</button>
          </div>
        </div>
        <div class="fg__refine-divider"><span>How does it fit? <em>(optional)</em></span></div>
        <div class="fg__field">
          <label class="fg__field-label">Band fit</label>
          <input type="hidden" name="bandFit" value="well">
          <div class="fg__pill-row" data-fg-pill-group="bandFit">
            <button type="button" class="fg__pill" data-value="tight">Too tight</button>
            <button type="button" class="fg__pill fg__pill--active" data-value="well">Fits well</button>
            <button type="button" class="fg__pill" data-value="loose">Too loose</button>
          </div>
        </div>
        <div class="fg__field">
          <label class="fg__field-label">Cup fit</label>
          <input type="hidden" name="cupFit" value="well">
          <div class="fg__pill-row" data-fg-pill-group="cupFit">
            <button type="button" class="fg__pill" data-value="small">Too small</button>
            <button type="button" class="fg__pill fg__pill--active" data-value="well">Fits well</button>
            <button type="button" class="fg__pill" data-value="large">Too large</button>
          </div>
        </div>
        <p class="fg__error" data-fg-error style="display:none"></p>
        <div class="fg__submit-bar"><button type="submit" class="fg__submit">Find my fit</button></div>
      </form>
    `),
    B: tpl(`
      <form data-fg-form data-method="C" class="fg__form fg__form--measure">
        <p class="fg__instruction">Measure snugly around the fullest part of your bust</p>
        <div class="fg__measure-layout">
          <img src="FG_MEASURE_SRC" alt="Measurement diagram" class="fg__measure-diagram">
          <div class="fg__measure-inputs">
            <div class="fg__field">
              <label class="fg__field-label" for="fg-underbust">Underbust</label>
              <input type="number" id="fg-underbust" name="underbust" placeholder="e.g. 78 cm" min="60" max="110">
            </div>
            <div class="fg__field">
              <label class="fg__field-label" for="fg-overbust">Overbust</label>
              <input type="number" id="fg-overbust" name="overbust" placeholder="e.g. 90 cm" min="70" max="130">
            </div>
          </div>
        </div>
        <p class="fg__error" data-fg-error style="display:none"></p>
        <div class="fg__submit-bar"><button type="submit" class="fg__submit">Find my fit</button></div>
      </form>
    `),
    C: tpl(`
      <form data-fg-form data-method="B" class="fg__form">
        <p class="fg__instruction">Use the size of a regular-fit t-shirt</p>
        <div class="fg__field">
          <label class="fg__field-label" for="fg-tshirt">Clothing size (AU)</label>
          <select id="fg-tshirt" name="tshirtSize" class="fg__select">
            <option value="">Select size</option>
            <option value="XS">6 / XS</option>
            <option value="S">8 / S</option>
            <option value="M">10 / M</option>
            <option value="L">12 / L</option>
            <option value="XL">14 / XL</option>
          </select>
        </div>
        <div class="fg__field">
          <label class="fg__field-label">Bust shape</label>
          <input type="hidden" name="bustShape" value="">
          <div class="fg__pill-row" data-fg-pill-group="bustShape">
            <button type="button" class="fg__pill" data-value="small">Smaller</button>
            <button type="button" class="fg__pill" data-value="average">Average</button>
            <button type="button" class="fg__pill" data-value="full">Fuller</button>
          </div>
        </div>
        <p class="fg__error" data-fg-error style="display:none"></p>
        <div class="fg__submit-bar"><button type="submit" class="fg__submit">Find my fit</button></div>
      </form>
    `)
  };

  // ── HTML builders ─────────────────────────────────────────────

  function buildPdpTriggerHTML() {
    return '';
  }

  var FG_CONTACT_URL = '/pages/contact';

  function _chatBtn() {
    try {
      var chat = document.querySelector('shopify-chat');
      var sr = chat && chat.shadowRoot;
      if (!sr) return null;
      var runtime = sr.querySelector('shopify-agent-runtime');
      var btn = runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('button[part="activator"]');
      return btn || sr.querySelector('button[part="activator"]');
    } catch (e) { return null; }
  }

  function openChat() {
    if (_chatBtn()) {
      setTimeout(function () {
        var btn = _chatBtn();
        if (btn) btn.click();
        else window.location = FG_CONTACT_URL;
      }, 50);
      return;
    }
    window.location = FG_CONTACT_URL;
  }

  function contactLink(label) {
    return '<button type="button" class="fg__link fg__contact-link" data-fg-action="contact" style="font:inherit;color:inherit;text-transform:inherit;background:none;border:none;padding:0;cursor:pointer;text-decoration:underline;">' + (label || 'get in touch') + '</button>';
  }

  function buildPdpCalloutHTML(opts) {
    // opts: { result, state, brandSize, isSupport, equivUrl, equivTitle }
    // state: 'normal' | 'fallback' | 'redirect_support' | 'unavailable' | 'support_no_size'
    var result      = opts.result;
    var state       = opts.state;
    var brandSize   = opts.brandSize;
    var isSupport   = opts.isSupport;
    var equivUrl    = opts.equivUrl;
    var equivTitle  = opts.equivTitle || 'the Support Bra';
    var isBraSize = function (s) { return s && /^\d+[A-Za-z]+$/.test(s); };
    var brandSizeIsBra = isBraSize(brandSize || result.size);
    var sisters     = brandSizeIsBra ? (result.sisters || []).filter(isBraSize) : [];
    var primarySize = result.size;

    var equivSize = result.usSupport || null;
    var equivRow = (!isSupport && equivUrl && equivSize && state !== 'redirect_support')
      ? '<div class="fg__pdp-row"><h6 style="text-transform:uppercase;font-weight:normal">For more support, try <strong>' + equivSize + '</strong> in <a href="' + equivUrl + '" class="fg__result-equiv-link">the ' + equivTitle + '</a></h6></div>'
      : '';

    var mainRow;

    if (state === 'redirect_support') {
      // Understatement standard product, no standard size — redirect to support bra
      mainRow = equivUrl
        ? 'For the best fit, we recommend <a href="' + equivUrl + '" class="fg__result-equiv-link">the ' + equivTitle + '</a> in <strong>' + equivSize + '</strong>'
        : 'For the best fit, try the ' + equivTitle + ' in <strong>' + equivSize + '</strong>';
      equivRow = ''; // already covered in main row

    } else if (state === 'unavailable') {
      var sisterLinks = sisters.length
        ? sisters.map(function (s) { return '<strong>' + s + '</strong>'; }).join(' or ')
        : '';
      var unavailRow2 = sisterLinks
        ? 'You can try ' + sisterLinks + ' or ' + contactLink('Get in touch') + ', we\'d love to help'
        : contactLink('Get in touch') + ', we\'d love to help';
      return tpl(`
        <div class="fg__pdp-block">
          <div class="fg__pdp-row"><h6 style="text-transform:uppercase;font-weight:normal">Your recommended size <strong>${brandSize || primarySize}</strong> is currently unavailable. ${unavailRow2}</h6></div>
        </div>
      `);

    } else if (state === 'support_no_size') {
      var sisterRow = sisters.length
        ? '<div class="fg__pdp-row"><h6 style="text-transform:uppercase;font-weight:normal">You can try ' + sisters.map(function (s) { return '<strong>' + s + '</strong>'; }).join(' or ') + ' or ' + contactLink('Get in touch') + ', we\'d love to help</h6></div>'
        : '<div class="fg__pdp-row"><h6 style="text-transform:uppercase;font-weight:normal">' + contactLink('Get in touch') + ', we\'d love to help</h6></div>';
      return tpl(`
        <div class="fg__pdp-block">
          <div class="fg__pdp-row"><h6 style="text-transform:uppercase;font-weight:normal">This style may not be available in your size</h6></div>
          ${sisterRow}
        </div>
      `);

    } else {
      // normal or fallback
      var displaySize = brandSize || primarySize;
      mainRow = (brandSize && brandSize !== primarySize)
        ? 'For your fit <strong>' + primarySize + '</strong> we recommend size <strong>' + brandSize + '</strong> in this piece'
        : 'For your fit, we recommend size <strong>' + displaySize + '</strong> in this piece';
    }

    return tpl(`
      <div class="fg__pdp-block">
        <div class="fg__pdp-row"><h6 style="text-transform:uppercase;font-weight:normal">${mainRow}</h6></div>
        ${equivRow}
      </div>
    `);
  }

  function assetUrl(key, filename) {
    var assets = (typeof FITGUIDE_ASSETS !== 'undefined') ? FITGUIDE_ASSETS : null;
    if (assets && assets[key]) return assets[key];
    var base = (typeof FITGUIDE_ASSET_BASE !== 'undefined') ? FITGUIDE_ASSET_BASE : '';
    return base ? base + filename : '';
  }

  function buildOnboardingHTML() {
    var tape    = assetUrl('tape',   'fg-icon-tape.png');
    var bra     = assetUrl('bra',    'fg-icon-bra.png');
    var tshirt  = assetUrl('tshirt', 'fg-icon-tshirt.png');
    return tpl(`
      <div class="fg__options fg__options--grid">
        <button class="fg__option fg__option--card" data-fg-action="goto-form" data-method="B">
          ${tape ? '<img src="' + tape + '" alt="" class="fg__option-icon" aria-hidden="true">' : ''}
          <strong>Use Measurements</strong>
        </button>
        <button class="fg__option fg__option--card" data-fg-action="goto-form" data-method="A">
          ${bra ? '<img src="' + bra + '" alt="" class="fg__option-icon" aria-hidden="true">' : ''}
          <strong>Use my Bra Size</strong>
        </button>
        <button class="fg__option fg__option--card" data-fg-action="goto-form" data-method="C">
          ${tshirt ? '<img src="' + tshirt + '" alt="" class="fg__option-icon" aria-hidden="true">' : ''}
          <strong>Use my Clothing Size</strong>
        </button>
      </div>
    `);
  }

  function buildFormHTML(activeTab) {
    var tabs = [
      { method: 'B', label: 'Measurements' },
      { method: 'A', label: 'Bra size' },
      { method: 'C', label: 'Clothing size' }
    ];
    var tabsHtml = tabs.map(function (t) {
      return '<button class="fg__modal-tab' + (t.method === activeTab ? ' fg__modal-tab--active' : '') +
        '" data-fg-action="switch-tab" data-method="' + t.method + '">' + t.label + '</button>';
    }).join('');
    var formHtml = FORM_TEMPLATES[activeTab].replace('FG_MEASURE_SRC', assetUrl('measure', 'fg-icon-measure.png'));
    return tpl(`
      <div class="fg__form-nav">
        <div class="fg__modal-tabs">${tabsHtml}</div>
      </div>
      <div data-fg-form-body>${formHtml}</div>
    `);
  }

  function buildResultsHTML(result, isSupport, equivProductUrl, equivProductTitle, brandSize, productTitle, hideSave) {
    var isBraSize = function (s) { return s && /^\d+[A-Za-z]+$/.test(s); };
    var displaySisters = (result.sisters || []).filter(isBraSize);
    var sisterHtml = displaySisters.length
      ? '<div class="fg__result-confidence">You can also try ' +
          displaySisters.map(function (s) { return '<strong>' + s + '</strong>'; }).join(' or ') +
          ' &nbsp;|&nbsp; <a href="https://primarystore.com.au/blogs/news/understanding-sister-sizing" target="_blank" class="fg__sisters-link">More about Sister Sizing</a></div>'
      : '';

    var productRecoHtml = (brandSize && productTitle)
      ? '<div class="fg__result-product-reco">We\'ll suggest a unique fit for you for every Primary product. For the <strong>' + productTitle + '</strong>, we recommend <strong>' + brandSize + '</strong>.</div>'
      : '';

    var equivSize = result.usSupport || null;
    var equivLabel = equivProductTitle || 'the Support Bra';
    var equivHtml = (!isSupport && equivProductUrl && equivSize)
      ? '<div class="fg__result-equiv">For more support, try <strong>' + equivSize + '</strong> in <a href="' + equivProductUrl + '" class="fg__result-equiv-link">the ' + equivLabel + '</a></div>'
      : '';

    var brandRowsHtml = BRAND_ROWS.map(function (row) {
      var vals = row.keys.map(function (k) { return result[k] || null; }).filter(Boolean);
      if (!vals.length) return '';
      var labelHtml = row.url
        ? '<a href="' + row.url + '" class="fg__brand-link">' + row.label + '</a>'
        : row.label;
      return '<tr><td class="fg__brand-name">' + labelHtml + '</td>' +
        '<td class="fg__brand-val">' + vals.join(' or ') + '</td></tr>';
    }).join('');

    return tpl(`
      <div class="fg__result-primary">
        <div class="fg__result-label">Your Primary fit</div>
        <div class="fg__result-size">${result.size}</div>
        ${sisterHtml}
      </div>
      ${productRecoHtml}
      ${equivHtml}
      <table class="fg__brands fg__brands--modal" aria-label="Brand equivalents">
        <thead><tr><th>Brand</th><th>Your size</th></tr></thead>
        <tbody>${brandRowsHtml}</tbody>
      </table>
      <div class="fg__result-restart"><button class="fg__link" data-fg-action="back">Start over ↺</button></div>
      ${hideSave ? '' : '<div class="fg__submit-bar"><button class="fg__submit" data-fg-action="save">Save my fit</button></div>'}
    `);
  }

  function buildPromptHTML() {
    return '<button class="fg__prompt-btn" data-fg-action="open-onboarding">Find your fit</button>';
  }

  function buildSavedHTML(result) {
    return tpl(`
      <div class="fg__panel fg__saved-callout">
        <div class="fg__saved-label">Your saved size</div>
        <div class="fg__saved-size">${result.size}</div>
        <button class="fg__link" data-fg-action="open-onboarding">Recalculate</button>
      </div>
    `);
  }


  // ── Widget ────────────────────────────────────────────────────

  var _fgModalActive = false; // prevent double-open when multiple instances exist

  // True while _selectVariant is programmatically clicking — lets the global size-click
  // listener ignore our own clicks and only record genuine user interactions.
  var _fgAutoSelecting = false;

  // Timestamp of the last user-initiated size pick. Auto-select is suppressed for
  // _SUPPRESS_MS after the user manually changes size, preventing the widget from
  // snapping the picker back on AJAX re-renders triggered by that size change.
  // Colour swatch clicks do NOT update this timestamp (they use different DOM elements),
  // so colour changes always trigger a fresh auto-select regardless.
  var _userClickedSizeAt = 0;
  var _SUPPRESS_MS = 5000;

  // Set up global listener once (capture phase so it fires before theme handlers).
  // Only records size-option radios whose label text matches a known variant size —
  // this excludes colour/style radios even if they also use data-option-position.
  (function () {
    document.addEventListener('click', function (e) {
      if (_fgAutoSelecting) return;
      var target = e.target;
      // Resolve label clicks to their associated radio
      if (target.tagName === 'LABEL') {
        var associated = target.htmlFor ? document.getElementById(target.htmlFor) : target.querySelector('input[type="radio"]');
        if (associated) target = associated;
      }
      if (!target || target.type !== 'radio' || !target.dataset.optionPosition) return;
      // Check label text against current widget's variantSizes
      var lbl = (target.id && document.querySelector('label[for="' + target.id + '"]')) || target.closest('label');
      if (!lbl) return;
      var spanEl = lbl.querySelector('span:not(.sr-only)');
      var text = (spanEl ? spanEl.textContent : lbl.textContent).trim();
      var mounts = document.querySelectorAll('[data-fit-guide-mount]');
      for (var i = 0; i < mounts.length; i++) {
        var w = mounts[i]._fgWidget;
        if (w && w.variantSizes.indexOf(text) !== -1) {
          _userClickedSizeAt = Date.now();
          break;
        }
      }
    }, true);
  }());

  function FitGuideWidget(el) {
    this.el        = el;
    this.context   = el.dataset.context || '';
    this.fitValue  = parseInt(el.dataset.fitValue, 10) || 50;
    this.isSupport = el.dataset.fitUsSupportBra === 'true';
    this.equivUrl   = el.dataset.fitEquivProduct || '';
    this.equivTitle = el.dataset.fitEquivTitle || '';

    this.productTitle  = el.dataset.fitProductTitle || '';
    this.fitBrand      = (el.dataset.fitBrand || '').toLowerCase().trim();
    this.productHandle = el.dataset.fitProductHandle || '';
    this.variantSizes  = el.dataset.fitVariants
      ? el.dataset.fitVariants.split(',').map(function (s) { return s.trim(); })
      : [];

    this._modal           = null;
    this._modalBody       = null;
    this._modalEscHandler = null;
    this._activeTab       = 'A';
    this._lastResult      = null;

    this._render();
    this._refreshVariantSizes();
    this._loadFromKlaviyo();

    if (this.context === 'pdp') {
      var self = this;
      this._updateVariantPickerBtn();
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fg-action="open-modal"]');
        if (btn && !self.el.contains(btn)) {
          var hasSaved = !!(self._lastResult || self._loadSaved());
          self._openModal(hasSaved);
        }
      });
    }
  }

  FitGuideWidget.prototype._refreshVariantSizes = function () {
    if (!this.productHandle) return;
    var self = this;
    var sizeOptionName = 'Size';
    fetch('/products/' + this.productHandle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var sizeIdx = -1;
        if (data.options) {
          for (var i = 0; i < data.options.length; i++) {
            var optName = typeof data.options[i] === 'object' ? data.options[i].name : data.options[i];
            if (optName.toLowerCase() === 'size') { sizeIdx = i; break; }
          }
        }
        if (sizeIdx === -1) return;
        var live = [];
        (data.variants || []).forEach(function (v) {
          if (v.available) {
            var sz = v.options[sizeIdx];
            if (sz && live.indexOf(sz) === -1) live.push(sz);
          }
        });
        // Only re-render if sizes differ from what Liquid rendered
        var current = self.variantSizes.slice().sort().join(',');
        var fresh   = live.slice().sort().join(',');
        if (current !== fresh) {
          self.variantSizes = live;
          if (self.context === 'pdp' && self._loadSaved()) self._renderPdp();
        }
      })
      .catch(function () {});
  };

  FitGuideWidget.prototype._findBrandSize = function (result) {
    if (!result) return null;
    var brandEntry = null;
    for (var i = 0; i < BRAND_LOOKUP.length; i++) {
      if (BRAND_LOOKUP[i].vendors.indexOf(this.fitBrand) !== -1) {
        brandEntry = BRAND_LOOKUP[i];
        break;
      }
    }
    if (!brandEntry) return null;
    // Understatement: use only the relevant key for this product type
    var keys = (this.fitBrand === 'understatement')
      ? (this.isSupport ? ['usSupport'] : ['usStandard'])
      : brandEntry.keys;
    var firstNonNull = null;
    for (var j = 0; j < keys.length; j++) {
      var val = result[keys[j]];
      if (!val) continue;
      if (!firstNonNull) firstNonNull = val;
      // Prefer the part of a combined size (e.g. "S/M") that exists in this product's variants
      if (this.variantSizes.length) {
        if (this.variantSizes.indexOf(val) !== -1) return val;
        var parts = val.split('/');
        if (parts.length > 1) {
          for (var k = 0; k < parts.length; k++) {
            if (this.variantSizes.indexOf(parts[k].trim()) !== -1) return parts[k].trim();
          }
        }
        continue; // No variant match — try next key
      }
      return val; // No variant info — return first non-null
    }
    return firstNonNull; // Variant info known but no key matched — return first non-null for display
  };

  FitGuideWidget.prototype._sizeInVariants = function (size) {
    if (!size) return true;
    if (!this.variantSizes.length) return false; // All sold out
    if (this.variantSizes.indexOf(size) !== -1) return true;
    var parts = size.split('/');
    if (parts.length > 1) {
      for (var i = 0; i < parts.length; i++) {
        if (this.variantSizes.indexOf(parts[i].trim()) !== -1) return true;
      }
    }
    return false;
  };

  FitGuideWidget.prototype._render = function () {
    if (this.context === 'pdp') {
      this._renderPdp();
    } else {
      this._renderInline();
    }
    // Sync identify to Klaviyo once per unique fit result. Fires on every page load
    // until Klaviyo has resolved identity — after that, only re-fires if fit changes.
    this._syncKlaviyoIdentify();
  };

  FitGuideWidget.prototype._pdpCalloutOpts = function (result) {
    var bs = this._findBrandSize(result);
    var state;
    if (this.fitBrand === 'understatement') {
      if (this.isSupport) {
        state = bs ? (this._sizeInVariants(bs) ? 'normal' : 'unavailable') : 'support_no_size';
      } else {
        if (!bs) {
          state = result.usSupport ? 'redirect_support' : 'fallback';
        } else {
          state = this._sizeInVariants(bs) ? 'normal' : 'unavailable';
        }
      }
    } else if (bs) {
      state = this._sizeInVariants(bs) ? 'normal' : 'unavailable';
    } else {
      state = this._sizeInVariants(result.size) ? 'fallback' : 'unavailable';
      if (state === 'unavailable') bs = result.size;
    }
    return { result: result, state: state, brandSize: bs, isSupport: this.isSupport, equivUrl: this.equivUrl, equivTitle: this.equivTitle };
  };

  // forceSelect: pass true when the user just calculated a new fit (e.g. after modal submit)
  // to snap the picker to the newly recommended size regardless of any suppression.
  // Otherwise: auto-select fires unless the user manually changed size within _SUPPRESS_MS.
  // Colour changes don't update _userClickedSizeAt, so colour re-renders always auto-select.
  FitGuideWidget.prototype._renderPdp = function (forceSelect) {
    var saved = this._loadSaved();
    if (saved) {
      this.el.innerHTML = buildPdpCalloutHTML(this._pdpCalloutOpts(saved));
      var recentUserPick = (Date.now() - _userClickedSizeAt) < _SUPPRESS_MS;
      if (forceSelect || !recentUserPick) {
        this._selectVariant(this._findBrandSize(saved) || saved.primary);
      }
    } else {
      this.el.innerHTML = buildPdpTriggerHTML();
    }
    this._bindRoot();
  };

  FitGuideWidget.prototype._renderInline = function () {
    var self = this;
    var saved = this._loadSaved();
    if (saved) {
      this._lastResult = saved;
      this.el.innerHTML = '<div class="fg__panel">' + buildResultsHTML(saved, false, '', '', null, null, true) + '</div>';
      var panel = this.el.querySelector('.fg__panel');
      var footerEl = document.createElement('div');
      footerEl.className = 'fg__inline-email-footer';
      var saveBtn = document.createElement('button');
      saveBtn.className = 'fg__submit';
      saveBtn.setAttribute('data-fg-action', 'save');
      saveBtn.textContent = 'SAVE MY FIT';
      footerEl.appendChild(saveBtn);
      panel.appendChild(footerEl);
      this._injectEmailFooter(footerEl, saved);
    } else if (this.context === 'page') {
      this.el.innerHTML = '<div class="fg__panel fg__panel--onboarding">' + buildOnboardingHTML() + '</div>';
    } else {
      this.el.innerHTML = buildPromptHTML();
    }
    this._bindRoot();
  };

  FitGuideWidget.prototype._bindRoot = function () {
    var self = this;
    // Replace innerHTML before this call ensures old listeners are GC'd,
    // but el itself persists — use AbortController to avoid accumulation.
    if (this._rootAbort) this._rootAbort.abort();
    this._rootAbort = new AbortController();
    var sig = { signal: this._rootAbort.signal };
    this.el.addEventListener('click', function (e) { self._handleRootClick(e); }, sig);
    this.el.addEventListener('submit', function (e) { self._handleInlineSubmit(e); }, sig);
    this._bindPills(this.el);
  };

  FitGuideWidget.prototype._bindPills = function (container) {
    container.querySelectorAll('[data-fg-pill-group]').forEach(function (group) {
      var name = group.dataset.fgPillGroup;
      var hidden = group.closest('form') && group.closest('form').querySelector('input[name="' + name + '"]');
      group.querySelectorAll('.fg__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.fg__pill').forEach(function (p) { p.classList.remove('fg__pill--active'); });
          pill.classList.add('fg__pill--active');
          if (hidden) hidden.value = pill.dataset.value;
        });
      });
    });
  };

  FitGuideWidget.prototype._handleRootClick = function (e) {
    var btn = e.target.closest('[data-fg-action]');
    if (!btn) return;
    var action = btn.dataset.fgAction;

    if (action === 'contact') { openChat(); return; }

    if (this.context === 'pdp') {
      if (action === 'open-modal') this._openModal();
      else if (action === 'open-results') this._openModal(true);
      return;
    }

    // Inline actions
    if (action === 'open-onboarding') {
      this.el.innerHTML = '<div class="fg__panel fg__panel--onboarding">' + buildOnboardingHTML() + '</div>';
      this._bindRoot();
    } else if (action === 'goto-form') {
      this._activeTab = btn.dataset.method;
      this.el.innerHTML = '<div class="fg__panel">' + buildFormHTML(this._activeTab) + '</div>';
      this._bindRoot();
    } else if (action === 'switch-tab') {
      this._activeTab = btn.dataset.method;
      var formBody = this.el.querySelector('[data-fg-form-body]');
      if (formBody) {
        formBody.innerHTML = FORM_TEMPLATES[this._activeTab].replace('FG_MEASURE_SRC', assetUrl('measure', 'fg-icon-measure.png'));
        this.el.querySelectorAll('.fg__modal-tab').forEach(function (t) {
          t.classList.toggle('fg__modal-tab--active', t.dataset.method === this._activeTab);
        }, this);
        this._bindPills(this.el);
      }
    } else if (action === 'back') {
      this.el.innerHTML = '<div class="fg__panel fg__panel--onboarding">' + buildOnboardingHTML() + '</div>';
      this._bindRoot();
    } else if (action === 'back-to-form') {
      this.el.innerHTML = '<div class="fg__panel">' + buildFormHTML(this._activeTab) + '</div>';
      this._bindRoot();
    } else if (action === 'save') {
      if (this._lastResult) {
        this._saveSaved(this._lastResult);
        document.dispatchEvent(new CustomEvent('fitguide:saved', { detail: this._lastResult }));
      }
      this._renderInline();
    }
  };

  FitGuideWidget.prototype._handleInlineSubmit = function (e) {
    var form = e.target.closest('[data-fg-form]');
    if (!form) return;
    e.preventDefault();
    var self = this;
    this._calculate(form, function (result) {
      self._lastResult = result;
      self._saveSaved(result);
      self._fireKlaviyo(result);
      var bs = self._findBrandSize(result);
      self.el.innerHTML = '<div class="fg__panel">' + buildResultsHTML(result, self.isSupport, self.equivUrl, self.equivTitle, bs, self.productTitle, true) + '</div>';
      // Append inline email footer container after results
      var panel = self.el.querySelector('.fg__panel');
      var footerEl = document.createElement('div');
      footerEl.className = 'fg__inline-email-footer';
      var saveBtn = document.createElement('button');
      saveBtn.className = 'fg__submit';
      saveBtn.setAttribute('data-fg-action', 'save');
      saveBtn.textContent = 'SAVE MY FIT';
      footerEl.appendChild(saveBtn);
      panel.appendChild(footerEl);
      self._injectEmailFooter(footerEl, result);
      self._bindRoot();
    });
  };

  // ── Modal (PDP only) ──────────────────────────────────────────

  FitGuideWidget.prototype._openModal = function (showResults) {
    if (this._modal || _fgModalActive) return;
    _fgModalActive = true;
    var self = this;
    var overlay = document.createElement('div');
    overlay.className = 'fg__modal-overlay';
    overlay.innerHTML = tpl(`
      <div class="fg__modal-dialog fg__modal--onboarding" role="dialog" aria-modal="true" aria-label="Find your fit">
        <div class="fg__modal-header">
          <button class="fg__modal-back" data-fg-modal="back" aria-label="Back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg>
          </button>
          <span class="fg__modal-title">FIND YOUR FIT</span>
          <button class="fg__modal-close" data-fg-modal="close" aria-label="Close">×</button>
        </div>
        <div class="fg__modal-body" data-fg-modal-body></div>
        <div class="fg__modal-footer" data-fg-modal-footer></div>
      </div>
    `);

    this._modal = overlay;
    this._modalBody = overlay.querySelector('[data-fg-modal-body]');
    this._modalFooter = overlay.querySelector('[data-fg-modal-footer]');
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var dialog = overlay.querySelector('.fg__modal-dialog');
    function setOnboarding(on) {
      dialog.classList.toggle('fg__modal--onboarding', on);
    }

    function swapBody(html) {
      var from = dialog.offsetHeight;
      self._modalBody.innerHTML = html;
      var to = dialog.offsetHeight;
      if (from === to) return;
      dialog.style.minHeight = '0';
      dialog.style.transition = 'none';
      dialog.style.height = from + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dialog.style.transition = 'height 0.25s ease';
          dialog.style.height = to + 'px';
          dialog.addEventListener('transitionend', function done() {
            dialog.style.height = '';
            dialog.style.transition = '';
            dialog.style.minHeight = '';
            dialog.removeEventListener('transitionend', done);
          });
        });
      });
    }

    function injectEmailFooter(result) {
      self._injectEmailFooter(self._modalFooter, result);
    }

    function liftSubmitBar() {
      self._modalFooter.innerHTML = '';
      var bar = self._modalBody.querySelector('.fg__submit-bar');
      if (bar) {
        var form = self._modalBody.querySelector('[data-fg-form]');
        if (form) {
          form.id = 'fg-active-form';
          var submitBtn = bar.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.setAttribute('form', 'fg-active-form');
        }
        self._modalFooter.appendChild(bar);
      }
    }

    var savedResult = showResults && (self._lastResult || self._loadSaved());
    if (savedResult) {
      var bs = self._findBrandSize(savedResult);
      swapBody(buildResultsHTML(savedResult, self.isSupport, self.equivUrl, self.equivTitle, bs, self.productTitle));
      setOnboarding(false);
    } else {
      swapBody(buildOnboardingHTML());
    }
    liftSubmitBar();
    if (savedResult) injectEmailFooter(savedResult);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { self._closeModal(); return; }

      var btn = e.target.closest('[data-fg-modal], [data-fg-action]');
      if (!btn) return;
      var action = btn.dataset.fgModal || btn.dataset.fgAction;

      if (action === 'contact') { openChat(); return; }
      if (action === 'close') {
        self._closeModal();
      } else if (action === 'goto-form') {
        self._activeTab = btn.dataset.method;
        swapBody(buildFormHTML(self._activeTab));
        self._bindPills(overlay);
        liftSubmitBar();
        setOnboarding(false);
      } else if (action === 'switch-tab') {
        self._activeTab = btn.dataset.method;
        var formBody = overlay.querySelector('[data-fg-form-body]');
        if (formBody) {
          formBody.innerHTML = FORM_TEMPLATES[self._activeTab].replace('FG_MEASURE_SRC', assetUrl('measure', 'fg-icon-measure.png'));
          overlay.querySelectorAll('.fg__modal-tab').forEach(function (t) {
            t.classList.toggle('fg__modal-tab--active', t.dataset.method === self._activeTab);
          });
          self._bindPills(overlay);
          liftSubmitBar();
        }
      } else if (action === 'back') {
        swapBody(buildOnboardingHTML());
        liftSubmitBar();
        setOnboarding(true);
      } else if (action === 'back-to-form') {
        swapBody(buildFormHTML(self._activeTab));
        self._bindPills(overlay);
        liftSubmitBar();
        setOnboarding(false);
      } else if (action === 'save') {
        self._closeModal();
      }
    });

    overlay.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.target.closest('[data-fg-form]');
      if (!form) return;
      self._calculate(form, function (result) {
        self._lastResult = result;
        self._saveSaved(result);
        self._fireKlaviyo(result);
        if (self.context === 'pdp') {
          self._renderPdp(true); // forceSelect: snap picker to newly-calculated size
          self._updateVariantPickerBtn();
          self._selectVariant(self._findBrandSize(result) || result.primary);
          document.dispatchEvent(new CustomEvent('fitguide:saved', { detail: result, bubbles: true }));
        }
        var bs = self._findBrandSize(result);
        swapBody(buildResultsHTML(result, self.isSupport, self.equivUrl, self.equivTitle, bs, self.productTitle));
        liftSubmitBar();
        setOnboarding(false);
        injectEmailFooter(result);
      });
    });

    this._modalEscHandler = function (e) {
      if (e.key === 'Escape') self._closeModal();
    };
    document.addEventListener('keydown', this._modalEscHandler);
  };

  FitGuideWidget.prototype._injectEmailFooter = function (footer, result) {
    var self = this;

    function renderEmailRow(prefill, isSubscribed) {
      var emailRow = document.createElement('div');
      emailRow.className = 'fg__footer-email-row';
      var placeholder = 'Your email, please';
      var val = prefill ? ' value="' + prefill.replace(/"/g, '&quot;') + '"' : '';
      var consentHtml = isSubscribed
        ? ''
        : tpl(`<label class="fg__footer-consent">
            <input type="checkbox" class="fg__footer-consent-check" checked>
            Subscribe for occasional interesting emails, special offers and 10% off your first purchase.
          </label>`);
      emailRow.innerHTML = tpl(`
        <div class="fg__footer-email-inner">
          <p class="fg__footer-email-heading">Save your fit</p>
          <input type="email" class="fg__input fg__footer-email-input" placeholder="${placeholder}"${val} autocomplete="email">
          ${consentHtml}
        </div>
      `);
      footer.insertBefore(emailRow, footer.firstChild);

      var saveBtn = footer.querySelector('[data-fg-action="save"]');
      if (saveBtn) {
        saveBtn.addEventListener('click', function () {
          var emailInp = footer.querySelector('.fg__footer-email-input');
          var email = emailInp ? emailInp.value.trim() : '';
          if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            var consentCheck = footer.querySelector('.fg__footer-consent-check');
            var hasConsent = consentCheck && consentCheck.checked;
            if (root.FitGuide && root.FitGuide.klaviyo) {
              root.FitGuide.klaviyo._fire(function (kl) {
                var props = { email: email };
                if (hasConsent) props['$consent'] = ['email'];
                kl.identify(props);
                root.FitGuide.klaviyo.identify(result.band, result.cup, result.method, result.inputs);
              });
            }
          }
        });
      }
    }

    renderEmailRow(root.FG_CUSTOMER_EMAIL || '');
  };

  FitGuideWidget.prototype._updateVariantPickerBtn = function () {
    var btn = document.querySelector('[data-fg-action="open-modal"]');
    if (!btn) return;
    var h6 = btn.querySelector('h6');
    if (!h6) return;
    var hasSaved = !!(this._lastResult || this._loadSaved());
    h6.textContent = hasSaved ? 'Check your fit' : 'Find your fit';
  };

  FitGuideWidget.prototype._closeModal = function () {
    if (!this._modal) return;
    document.body.removeChild(this._modal);
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._modalEscHandler);
    this._modal = null;
    this._modalBody = null;
    this._modalEscHandler = null;
    _fgModalActive = false;
    if (this.context === 'pdp') { this._renderPdp(); this._updateVariantPickerBtn(); }
  };

  // ── Calculation ───────────────────────────────────────────────

  FitGuideWidget.prototype._calculate = function (form, cb) {
    var errEl = form.querySelector('[data-fg-error]');
    if (errEl) errEl.style.display = 'none';

    if (!root.FitGuide) {
      if (errEl) { errEl.textContent = 'Calculator not loaded.'; errEl.style.display = ''; }
      return;
    }

    var method = form.dataset.method;
    var fd = new FormData(form);
    var params = {};
    fd.forEach(function (v, k) { params[k] = v; });

    // Override with active pill values — more reliable than hidden inputs
    form.querySelectorAll('[data-fg-pill-group]').forEach(function (group) {
      var active = group.querySelector('.fg__pill--active');
      if (active) params[group.dataset.fgPillGroup] = active.dataset.value;
    });
    params.method = method;
    var result = root.FitGuide.recommend(params, this.fitValue);
    if (result) {
      result.size = result.primary;
      result.basis = result.confidenceLabel;
      // Normalize sisters from {tighter, looser} to flat array for display
      var sis = result.sisters || {};
      result.sisters = [sis.tighter, sis.looser].filter(Boolean);
      // Raw inputs for Klaviyo — what the customer actually entered
      result.inputs = params;
    }
    if (!result || result.error) {
      if (errEl) {
        errEl.textContent = (result && result.error) || 'Please fill in all fields.';
        errEl.style.display = '';
      }
      return;
    }
    cb(result);
  };

  // ── Variant auto-select ───────────────────────────────────────

  FitGuideWidget.prototype._selectVariant = function (size) {
    if (!size) return;

    // Flag our own programmatic clicks so the global size-click listener ignores them.
    _fgAutoSelecting = true;
    setTimeout(function () { _fgAutoSelecting = false; }, 200);

    // Prestige (and most themes): radio inputs with data-option-position; value is a
    // numeric Shopify ID, not the label string. Match by the associated label's text.
    var inputs = document.querySelectorAll('input[type="radio"][data-option-position]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var lbl = (inp.id && document.querySelector('label[for="' + inp.id + '"]')) || inp.closest('label');
      if (!lbl) continue;
      var spanEl = lbl.querySelector('span:not(.sr-only)');
      var text = spanEl ? spanEl.textContent.trim() : lbl.textContent.trim();
      if (text === size) {
        if (!inp.checked) inp.click();
        return;
      }
    }

    // Native select fallback
    var selects = document.querySelectorAll('select[name^="options"]');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      for (var k = 0; k < sel.options.length; k++) {
        if (sel.options[k].value === size || sel.options[k].text.trim() === size) {
          sel.value = sel.options[k].value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    // Button/pill style
    var btns = document.querySelectorAll('[data-option-value]');
    btns.forEach(function (btn) {
      if (btn.dataset.optionValue === size) btn.click();
    });
  };

  // ── Persistence ───────────────────────────────────────────────

  FitGuideWidget.prototype._loadSaved = function () {
    try {
      var r = localStorage.getItem('fg__saved');
      if (!r) return null;
      var data = JSON.parse(r);
      if (data && data.band && data.cup && root.FitGuide) {
        var fresh = root.FitGuide.recommend({ method: 'A', band: data.band, cup: data.cup }, this.fitValue);
        if (fresh) { fresh.size = fresh.primary; fresh.basis = fresh.confidenceLabel; var sis = fresh.sisters || {}; fresh.sisters = [sis.tighter, sis.looser].filter(Boolean); }
        return fresh;
      }
      return null;
    }
    catch (e) { return null; }
  };

  FitGuideWidget.prototype._saveSaved = function (result) {
    try {
      localStorage.setItem('fg__saved', JSON.stringify({ band: result.band, cup: result.cup, method: result.method || 'A', inputs: result.inputs || null }));
      localStorage.removeItem('fg__kl_synced'); // force re-sync on next page load
    } catch (e) {}
  };


  FitGuideWidget.prototype._loadFromKlaviyo = function () {
    // Skip if fit already saved locally
    try { if (localStorage.getItem('fg__saved')) return; } catch (e) { return; }
    if (!root.FitGuide || !root.FitGuide.klaviyo) return;

    // Get public company ID from Klaviyo's _learnq array
    var companyId = null;
    try {
      var lq = root._learnq;
      if (lq) {
        for (var i = 0; i < lq.length; i++) {
          if (Array.isArray(lq[i]) && lq[i][0] === 'account') { companyId = lq[i][1]; break; }
        }
      }
    } catch (e) {}
    if (!companyId) return;

    var self = this;
    root.FitGuide.klaviyo._fire(function (kl) {
      kl.isIdentified().then(function (identified) {
        if (!identified) return;
        fetch('https://a.klaviyo.com/client/profiles/?company_id=' + companyId, {
          headers: { 'revision': '2024-10-15' }
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var props = data && data.data && data.data.attributes && data.data.attributes.properties;
          if (!props) return;

          var band = null, cup = null, method = props.fit_method || 'A';

          // Prefer structured inputs stored at save time
          var inputs = props.fit_inputs;
          if (inputs && inputs.band && inputs.cup) {
            band = String(inputs.band);
            cup  = String(inputs.cup).toUpperCase();
          }

          // Fallback: parse fit_primary_size e.g. "10C", "12DD"
          if ((!band || !cup) && props.fit_primary_size) {
            var m = String(props.fit_primary_size).match(/^(\d+)([A-Za-z]+)$/);
            if (m) { band = m[1]; cup = m[2].toUpperCase(); }
          }

          if (!band || !cup) return;

          try {
            localStorage.setItem('fg__saved', JSON.stringify({ band: band, cup: cup, method: method }));
            // Mark synced so _syncKlaviyoIdentify won't immediately push it back
            localStorage.setItem('fg__kl_synced', band + '|' + cup);
          } catch (e) { return; }

          // Re-render now that we have data
          self._render();
        })
        .catch(function () {});
      });
    });
  };

  FitGuideWidget.prototype._syncKlaviyoIdentify = function () {
    try {
      var raw = localStorage.getItem('fg__saved');
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || !data.band || !data.cup) return;
      var key = data.band + '|' + data.cup;
      if (localStorage.getItem('fg__kl_synced') === key) return;
      if (!root.FitGuide || !root.FitGuide.klaviyo) return;
      var self = this;
      root.FitGuide.klaviyo._fire(function (kl) {
        kl.isIdentified().then(function (identified) {
          if (!identified) return;
          root.FitGuide.klaviyo.identify(data.band, data.cup, data.method || 'A', null);
          try { localStorage.setItem('fg__kl_synced', key); } catch (e) {}
        });
      });
    } catch (e) {}
  };

  FitGuideWidget.prototype._fireKlaviyo = function (result) {
    if (root.FitGuide && root.FitGuide.klaviyo) {
      root.FitGuide.klaviyo.identify(result.band, result.cup, result.method, result.inputs);
      root.FitGuide.klaviyo.track(result.method, result, window.location.href);
    }
  };

  // ── Init ──────────────────────────────────────────────────────

  function initMounts() {
    document.querySelectorAll('[data-fit-guide-mount]').forEach(function (el) {
      if (!el._fgWidget) {
        el._fgWidget = new FitGuideWidget(el);
      }
    });
  }

  // Reinitialize when Prestige AJAX re-renders the product section
  var _fgObserverTimer;
  var _fgObserver = new MutationObserver(function () {
    clearTimeout(_fgObserverTimer);
    _fgObserverTimer = setTimeout(initMounts, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMounts();
      _fgObserver.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    initMounts();
    _fgObserver.observe(document.body, { childList: true, subtree: true });
  }

  root.FitGuideWidget = FitGuideWidget;

}(window));
